import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { paymentTransactions, postGatewayPaymentChargeWallet } from 'services/wallet'
import posthog from 'posthog-js'

export default function useSetTransaction() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: any) => {
            return postGatewayPaymentChargeWallet(payload)
        },
        onSuccess: (result, variables) => {
            //@ts-ignore
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'wallet-charge',
                    data: [],
                    //@ts-ignore
                    // pk: result?.pk,
                    //@ts-ignore
                    // gateway: '',
                })
            )
            posthog.capture('payment_gateway_redirect', {
                flow_type: 'wallet_topup',
                amount: (variables as any)?.amount,
                gateway: (variables as any)?.gateway?.uniqueCode,
            })
            window.location.replace(result?.payment_link)
            toast.success('در حال انتقال به صفحه کارت به کارت')
        },
        onError: () => {
            posthog.capture('wallet_topup_failed')
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
